module.exports = __webpack_public_path__ + "static/media/zhengs2-3.bc3ee193.png";